import { createContext, useContext, useLayoutEffect } from "react";

export const TasksBoardPanelContext = createContext<(isShown: boolean) => void>(
    () => undefined,
);

/**
 * Sizes the Tasks split's list panel for Board's side panel while the caller
 * is mounted, so the card clicked open stays under the pointer.
 */
export const useTasksBoardPanelSizes = () => {
    const setIsBoardPanelShown = useContext(TasksBoardPanelContext);
    useLayoutEffect(() => {
        setIsBoardPanelShown(true);
        return () => setIsBoardPanelShown(false);
    }, [setIsBoardPanelShown]);
};
